import React, { createContext, useContext, useState, useCallback } from 'react';
import GetStartedDialog from '../components/GetStartedDialog';

const LeadDialogContext = createContext(null);

export const useLeadDialog = () => {
  const ctx = useContext(LeadDialogContext);
  if (!ctx) throw new Error('useLeadDialog must be used inside <LeadDialogProvider>');
  return ctx;
};

export const LeadDialogProvider = ({ children }) => {
  const [state, setState] = useState({ open: false, source: 'get-started', title: undefined, subtitle: undefined });

  const open = useCallback((opts = {}) => {
    setState({
      open: true,
      source: opts.source || 'get-started',
      title: opts.title,
      subtitle: opts.subtitle,
    });
  }, []);

  const onOpenChange = useCallback((next) => {
    setState((s) => ({ ...s, open: next }));
  }, []);

  return (
    <LeadDialogContext.Provider value={{ open }}>
      {children}
      <GetStartedDialog
        open={state.open}
        onOpenChange={onOpenChange}
        source={state.source}
        title={state.title}
        subtitle={state.subtitle}
      />
    </LeadDialogContext.Provider>
  );
};
